import { TipSourceTipType } from './tip-source-tip-type';

export const TipSourceConfigSchema = {
    tip_types: [TipSourceTipType]
};
